
export const RUPEE_SYMBOL="\u20B9";

